import { registerRoleGroupResolver } from 'app/core/components/RolePicker/roleGroupExtension';

export function initRoleGrouping() {
  // Temporary UI grouping until plugin and App Platform role provisioning are aligned.
  registerRoleGroupResolver((role) => {
    if (
      role.name.startsWith('plugins:grafana-assistant-app:') ||
      role.name.startsWith('fixed:assistant.ext.grafana.app:')
    ) {
      return { prefix: 'plugins', name: 'Grafana Assistant' };
    }
    return undefined;
  });
}
